import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import CustomControl from '../../../../../../../../components/global/CustomControl';

const propTypes = {
  matchedPhoto: PropTypes.shape({
    id: PropTypes.string,
    photo: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  selectable: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectToggle: PropTypes.func,
};
const MatchedPhotoSelectionAction = ({
  matchedPhoto,
  selectable,
  isSelected,
  onSelectToggle,
}) => {
  const { photo } = matchedPhoto;

  return (
    <Fragment>
      {selectable && (
        <Fragment>
          <div className="base-overlay" />
          <CustomControl
            id={`checkbox-${photo.id}`}
            className="matched-photo-selectable-custom-control"
            label={isSelected ? 'Photo selected' : 'Select this photo'}
            labelSrOnly
            type="checkbox"
            checked={isSelected}
            readOnly
            size="xxl"
            onClick={() => {
              onSelectToggle();
            }}
          />
        </Fragment>
      )}
      {!selectable && (
        <div
          className="matched-photo-unselectable-overlay"
          data-testid="matched-photo-selection-waldo-face-block"
          data-tip="Purchase photo first to download"
          data-for={`select-unentitled-photo-tip-${photo.id}`}
          data-effect="solid"
          data-place="bottom"
        >
          <ReactTooltip id={`select-unentitled-photo-tip-${photo.id}`} />
        </div>
      )}
    </Fragment>
  );
};

MatchedPhotoSelectionAction.propTypes = propTypes;
export default MatchedPhotoSelectionAction;
